module.exports = __webpack_public_path__ + "img/expand-arrows-alt-solid.24a66252.svg";